import * as Sentry from '@sentry/angular';
import { environment } from '@environment';

export function setSentryUser(user: Sentry.User | null) {
  Sentry.setUser(user);
}

export const isSentryEnabled = environment.name === 'production' || environment.name === 'testing';
